<template>
  <div
    style="border: 0px solid black; width:100%;"
    v-if="
      has_perm('view_apartment_schedule_progress') || GET_ACCOUNT_DATA.id == 1
    "
  >
    <div class="welcome" style="border: 0px solid red;">
      <row
        style="border:0px solid green;position: inherit;display:contents;width:100%;"
      >
        <div class="box box-primary" style="width:100%">
          <div class="box-header with-border">
            <div
              style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
            >
              <b>{{ $t("apartment_schedule_progress.title") }}</b>
              <lte-button
                v-if="
                  GET_ACCOUNT_DATA.id == 1 ||
                    has_perm('create_apartment_schedule_progress')
                "
                style="float:right;"
                type="btn
                btn-primary"
                right_icon="fa
                fa-plus"
                @click="addNew($event)"
                >{{ $t("common.add") }}</lte-button
              >
              <lte-button
                v-if="
                  GET_ACCOUNT_DATA.id == 1 ||
                    has_perm('delete_apartment_schedule_progress')
                "
                style="float:right"
                type="btn btn-danger"
                right_icon="glyphicon glyphicon-remove"
                @click="onDelete()"
                >{{
                  $t("apartment_schedule_progress.delete.button")
                }}</lte-button
              >
            </div>
            <select-option-check
              style="margin-top:-40px;"
              :item="columnsApartment"
              class="dropdown-trigger"
              data-icon="eye"
              @callbackData="onColumnSelect"
            ></select-option-check>
          </div>
          <div class="box-body">
            <lte-table
              ref="lte_table"
              :hdBackground="hdBackground"
              :data="gridApartmentDataList"
              :columns="gridColumns"
              search_filter="left-search"
              @actions="crudActions"
              :useFilter="useFilter"
              :actions="
                GET_ACCOUNT_DATA.id == 1 ||
                (has_perm('update_apartment_schedule_progress') &&
                  has_perm('delete_apartment_schedule_progress'))
                  ? actions
                  : has_perm('update_apartment_schedule_progress')
                  ? [actions[0]]
                  : has_perm('delete_apartment_schedule_progress')
                  ? [actions[1]]
                  : []
              "
              :row_mouse_pointer="false"
              :boxStyle="boxStyle"
              :isGetInformationInvoice="true"
              :useCheckBox="useCheckBox"
              @selectedItems="selectedItems"
              :customColumns="customColumns"
            ></lte-table>
          </div>
        </div>
        <div class="box-footer clearfix" style="display:contents;">
          <paginator :item="paginatorItem" @onpaginate="onPagination" />
        </div>
        <lte-core-alert
          v-for="snackbar in GET_SNACK_BAR"
          :key="snackbar.id"
          :item="snackbar"
        ></lte-core-alert>
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          color="#1E90FF"
        ></loading>
      </row>
    </div>
    <div class="modal fade" :ref="`modal-delete`">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t("apartment_schedule_progress.delete.title") }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row mb-1 margin-down-15">
              <div class="col-md-6 col-sm-6">
                <span>{{
                  $t("apartment_schedule_progress.delete.comment_head")
                }}</span>
                <span>{{ list_apartment_id.length }}</span>
                <span>{{
                  $t("apartment_schedule_progress.delete.comment_tail")
                }}</span>
              </div>
              <div class="col-md-64 col-sm-6">
                <label class="col-md-12 col-sm-12">{{
                  $t("apartment_schedule_progress.contract_number")
                }}</label>
                <span
                  v-for="item in list_apartment_code"
                  v-bind:key="item"
                  class="col-md-12 col-sm-12"
                  >{{ item }}</span
                >
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              @click="closeModalDelete()"
              class="btn btn-warning pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.back") }}
            </button>
            <button
              type="button"
              @click="deleteContract()"
              class="btn btn-primary"
            >
              {{ $t("common.confirm") }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { LTEActionTypeEnum } from '@/components/LTEEnum'
import LTEButton from "@/components/LTEButton.vue";
import LTETable from "@/components/LTETable.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Paginator from "@/components/Paginator.vue";
import Loading from "vue-loading-overlay";
import utils from '@/lib/utils';
import SelectOptionCheck from "@/components/SelectOptionCheck.vue";

export default {
  name: "ApartmentScheduleProgressList",
  data() {
    return {
      buttonName: "danger",
      labelName: "Name",
      gridApartmentDataList: [],
      useFilter: false,
      boxStyle: true,
      useCheckBox: true,
      list_apartment_id: [],
      list_apartment_code: [],
      gridColumns: [
        { text: "common.nonumber", isHidden: true },
        { text: "apartment_schedule_progress.contract_number", isHidden: true },
        { text: "apartment_schedule_progress.contract_name", isHidden: true },
        { text: "apartment_schedule_progress.date_from", isHidden: true },
        { text: "apartment_schedule_progress.date_to", isHidden: true },
        { text: "apartment_schedule_progress.progress", isHidden: true },
        { text: "apartment_schedule_progress.customer", isHidden: true },
        { text: "apartment_schedule_progress.phone", isHidden: true },
        { text: "apartment_schedule_progress.email", isHidden: true },
        { text: "apartment_schedule_progress.main_contact", isHidden: true },
        { text: "apartment_schedule_progress.support_contact", isHidden: true },
        { text: "apartment_schedule_progress.user_created", isHidden: true },
        { text: "apartment_schedule_progress.date_created", isHidden: true }
      ],
      customColumns: {
        "apartment_schedule_progress.progress": "none"
      },
      columnsApartment: {
        data_list: [],
        itemType: 1,
        showLabel: false,
        modifyFromPosition: "margin-top:-300px",
        cssClassSm1: "col-md-1",
        cssClassSm2: "col-sm-1",
        showAddNew: false
      },
      columnApartmentStatus: {
        data_list: [],
        itemType: 1,
        showLabel: false,
        modifyFromPosition: "margin-top:-300px",
        cssClassSm1: "col-md-1",
        cssClassSm2: "col-sm-1",
        showAddNew: false,
        apartment: true
      },
      actions: ["common.modify", "common.delete"],
      hdBackground:
        "background-color: #4b646f;color:white;border:1px solid white;", //00a65a
      tblBorder: "border: 1px solid orange",
      paginatorItem: {
        commit_function: "GET_APARTMENT_SCHEDULE_PROGRESS_LIST"
      },
      // search: {
      //   code: "",
      //   apartment_code: "",
      //   fromsize: "",
      //   tosize: "",
      //   status: "",
      //   owner_resident: ""
      // },
      isLoading: false
    };
  },
  watch: {
    GET_LANG: function() {
      this.columnApartmentStatus.data_list = [];
      const data = {
        params: {
          page: 1
        }
      };
      this.isLoading = true;
      this.GET_APARTMENT_SCHEDULE_PROGRESS_LIST(data);
    },

    GET_APARTMENT_SCHEDULE_PROGRESS_DATA: function() {
      this.gridApartmentDataList = [];
      this.GET_APARTMENT_SCHEDULE_PROGRESS_DATA.forEach((apartment, i) => {
        let nonumber =
          i + 1 + (this.PAGINATION.page - 1) * this.PAGINATION.size;
        let id = apartment.id;
        let contract_number = apartment.contract_number;
        let contract_name = apartment.contract_name;
        let date_from = utils.formatSqlDate(apartment.date_from, null, "DD/MM/YYYY", "");
        let date_to = utils.formatSqlDate(apartment.date_to, null, "DD/MM/YYYY", "");
        let progress = apartment.progress;

        let customer = apartment.customer;
        let phone = apartment.phone;
        let email = apartment.email;
        let main_contact = apartment.main_contact;
        let support_contact = apartment.support_contact;
        let user_created = apartment.user_created.name;
        let date_created = utils.formatSqlDate(apartment.date_created, null, "DD/MM/YYYY", "");

        let data = {
          id: id,
          "common.nonumber": nonumber,
          "apartment_schedule_progress.contract_number": contract_number,
          "apartment_schedule_progress.contract_name": contract_name,
          "apartment_schedule_progress.date_from": date_from,
          "apartment_schedule_progress.date_to": date_to,
          "apartment_schedule_progress.progress": progress + "%",
          "apartment_schedule_progress.customer": customer,
          "apartment_schedule_progress.phone": phone,
          "apartment_schedule_progress.email": email,
          "apartment_schedule_progress.main_contact": main_contact,
          "apartment_schedule_progress.support_contact": support_contact,
          "apartment_schedule_progress.user_created": user_created,
          "apartment_schedule_progress.date_created": date_created
        };
        this.gridApartmentDataList.push(data);
      });
      this.isLoading = false;
    },
    GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA: function() {
      if (!utils.isNull(this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data)) {
        const viewedColumnsKey = Object.keys(
          this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data.viewed_columns
        );
        const viewedColumns = this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data
          .viewed_columns;
        let newGridColumns = [];
        if (this.gridColumns.length == viewedColumns.length) {
          for (
            let j = 0, sizeOrigin = this.gridColumns.length;
            j < sizeOrigin;
            j++
          ) {
            for (let i = 0, size = viewedColumnsKey.length; i < size; i++) {
              if (this.gridColumns[j].text == viewedColumnsKey[i]) {
                let viewdColumnObject = {};
                viewdColumnObject.text = viewedColumnsKey[i];
                viewdColumnObject.isHidden = viewedColumns[viewedColumnsKey[i]];
                newGridColumns.push(viewdColumnObject);
                break;
              }
            }
          }
          this.gridColumns = newGridColumns;
          this.columnsApartment.data_list = this.gridColumns;
        }
        // update when add columns in table
        else if (this.gridColumns.length != viewedColumnsKey.length) {
          let updateGridColumns = [];
          for (let i = 0; i < this.gridColumns.length; i++) {
            for (let j = 0; j < viewedColumnsKey.length; j++) {
              if (this.gridColumns[i] != viewedColumnsKey[j]) {
                let viewdColumnObject = {};
                viewdColumnObject.text = this.gridColumns[i].text;
                viewdColumnObject.isHidden = viewedColumns[viewedColumnsKey[j]];
                updateGridColumns.push(viewdColumnObject);
                break;
              }
            }
          }
          this.gridColumns = updateGridColumns;
          this.columnsApartment.data_list = this.gridColumns;
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      "PAGINATION",
      "GET_SNACK_BAR",
      "GET_APARTMENT_SCHEDULE_PROGRESS_DATA",
      "GET_ACCOUNT_DATA",
      "GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA",
      "GET_LANG"
    ])
  },
  methods: {
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },

    // Chọn cột
    onColumnSelect: function(tables) {
      let tableDataObj = {};
      let tableDataObjChild = {};
      tableDataObjChild["tablename"] = "apartmentscheduleprogresslist";
      tables.data_list.forEach(element => {
        tableDataObj[element.text] = element.isHidden;
      });
      tableDataObjChild["tablerow"] = tableDataObj;
      this.SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG(tableDataObjChild)
        .then(function() {}.bind(this))
        .catch(function() {}.bind(this));
    },
    addNew: function() {
      this.$router.push({
        name: "ApartmentScheduleProgressAdd",
        params: {
          id: 0
        }
      });
    },
    crudActions: function(recordData, actionsType) {
      if (actionsType == LTEActionTypeEnum.MODIFY) {
        if (
          this.GET_ACCOUNT_DATA.id == 1 ||
          this.has_perm("update_apartment_schedule_progress")
        ) {
          this.$router.push({
            name: "ApartmentScheduleProgressAdd",
            params: {
              id: recordData.id
            }
          });
        } else {
          this.ON_SHOW_TOAST({
            message: this.$t(
              "apartment_schedule_progress.delete.not_permission"
            ),
            styleType: "danger"
          });
        }
      } else {
        if (
          this.GET_ACCOUNT_DATA.id == 1 ||
          this.has_perm("delete_apartment_schedule_progress")
        ) {
          this.$refs.lte_table.removeSelected();
          this.resetData();
          this.list_apartment_id.push(recordData.id);
          this.list_apartment_code.push(
            recordData["apartment_schedule_progress.contract_number"]
          );
          this.onDelete();
        } else {
          this.ON_SHOW_TOAST({
            message: this.$t(
              "apartment_schedule_progress.delete.not_permission"
            ),
            styleType: "danger"
          });
        }
      }
    },
    resetData() {
      this.list_apartment_id = [];
      this.list_apartment_code = [];
    },
    onPagination: function(data) {
      this.isLoading = true;
      this.GET_APARTMENT_SCHEDULE_PROGRESS_LIST(data);
    },
    selectedItems: function(dataSelected) {
      this.resetData();
      for (let i = 0, size = dataSelected.length; i < size; i++) {
        this.list_apartment_id.push(dataSelected[i].id);
        this.list_apartment_code.push(
          dataSelected[i]["apartment_schedule_progress.contract_number"]
        );
      }
    },
    onDelete: function() {
      if (this.list_apartment_id.length == 0) {
        this.ON_SHOW_TOAST({
          message: this.$t("apartment_schedule_progress.delete.error"),
          styleType: "danger"
        });
      } else {
        $(this.$refs[`modal-delete`]).modal("show");
      }
    },
    deleteContract: function() {
      let data = {
        data: this.list_apartment_id
      };
      this.isLoading = true;
      this.DELETE_APARTMENT_SCHEDULE_PROGRESS_LIST(data)
        .then(
          function() {
            this.SUCCESS_TOAST();
            this.resetData();
            this.onSearch(1);
            this.isLoading = false;
            $(this.$refs[`modal-delete`]).modal("hide");
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
            $(this.$refs[`modal-delete`]).modal("hide");
            this.ERROR_TOAST();
          }.bind(this)
        );
    },

    onSearch(page) {
      // Remove selected item in table before search
      this.$refs.lte_table.removeSelected();

      const data = {
        params: {
          page: page
        }
      };
      this.isLoading = true;
      this.GET_APARTMENT_SCHEDULE_PROGRESS_LIST(data).then(
        function() {
          this.isLoading = false;
        }.bind(this)
      );
      const filter = {
        params: {
          tablename: "apartmentscheduleprogresslist"
        }
      };
      this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG(filter);
    },

    closeModalDelete: function() {
      $(this.$refs[`modal-delete`]).modal("hide");
    },

    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "GET_APARTMENT_SCHEDULE_PROGRESS_LIST",
      "DELETE_APARTMENT_SCHEDULE_PROGRESS_LIST",
      "SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG",
      "GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG",
      "ON_SHOW_TOAST"
    ])
  },
  components: {
    "lte-button": LTEButton,
    "lte-table": LTETable,
    "lte-core-alert": LTECoreAlert,
    paginator: Paginator,
    loading: Loading,
    "select-option-check": SelectOptionCheck
  },
  mounted() {
    const data = {
      params: {
        page: 1
      }
    };
    // this.isLoading = true;
    this.GET_APARTMENT_SCHEDULE_PROGRESS_LIST(data);
    this.columnsApartment.data_list = this.gridColumns;
    const filter = {
      params: {
        tablename: "apartmentscheduleprogresslist"
      }
    };
    this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG(filter);
  }
};
</script>

<style scoped>
.search {
  box-shadow: none;
  border-color: #d2d6de;
  z-index: 2;
  float: left;
  margin-bottom: 8px;
  margin-right: 5px;
  height: 30px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 3px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.size-180 {
  width: 180px;
}

.search-tools {
  padding-right: 0px;
  padding-left: 0px;
  width: auto;
}
.select-option-status {
  margin-top: -12px;
  display: inline-block;
}

@media only screen and (max-width: 1000px) {
  .select-option-status {
    float: none;
    margin-top: 4px;
  }
}
@media only screen and (max-width: 768px) {
  .select-option-status {
    float: none;
    margin-top: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Apartment/ApartmentScheduleProgressList.vue